import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { AI_AGENT_HOST, ENVIRONMENT } from '../../config';

function* getAiPromptSuggestions() {
  try {
    const url = ENVIRONMENT === 'development'
      ? '/prompt-suggestions.json'
      : `${AI_AGENT_HOST}/prompt-suggestions.json`;
    const response = yield call([window, window.fetch], url);

    if (!response.ok) {
      yield put(actions.getAiPromptSuggestionsFailed({ message: `HTTP ${response.status}` }));
      return;
    }

    const data = yield call([response, response.json]);
    yield put(actions.getAiPromptSuggestionsDone(data));
  } catch (error) {
    yield put(actions.getAiPromptSuggestionsFailed({ message: error.message }));
  }
}

export const getAiPromptSuggestionsSaga = takeEvery(
  types.GET_AI_PROMPT_SUGGESTIONS_REQUEST,
  getAiPromptSuggestions
);
